import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import "./Address.css";

import customMap from "../../assets/images/custom_map.png";

const Address = () => {
  const revealRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const yOffset = -120;

      const element = revealRef.current;

      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }, 900);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>Visit Hiro | Hiro Japanese Buffet & Arcade</title>

        <meta
          name="description"
          content="Visit Hiro Japanese Buffet & Arcade in Aurora, Colorado."
        />

        <link
          rel="canonical"
          href="https://www.hirojapanesebuffet.com/address"
        />
      </Helmet>

      <div className="visit-page">
        {/* =========================
            CINEMATIC INTRO
        ========================= */}

        <section className="cinematic-hero">
          <div className="hero-map-glow"></div>

          <motion.div
            className="cinematic-content"
            initial={{
              opacity: 0,
              scale: 1.04,
              y: 30,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <motion.p
              className="visit-label"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.1,
              }}
            >
              VISIT HIRO
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1,
                delay: 0.15,
              }}
            >
              Located In Aurora,
              <br />
              Colorado
            </motion.h1>

            <motion.p
              className="visit-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1,
                delay: 0.25,
              }}
            >
              Conveniently located near H Mart on South Parker Road.
            </motion.p>
          </motion.div>
        </section>

        {/* =========================
            LOCATION EXPERIENCE
        ========================= */}

        <motion.section
          ref={revealRef}
          className="visit-layout"
          initial={{
            opacity: 0,
            y: 60,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
            amount: 0.15,
          }}
        >
          {/* LEFT SIDE */}

          <motion.div
            className="visit-sidebar"
            initial={{
              opacity: 0,
              x: -40,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.9,
              delay: 0.1,
            }}
            viewport={{ once: true }}
          >
            <h2 className="sidebar-logo">HIRO</h2>

            <div className="simple-info-block">
              <h3>Address:</h3>

              <a
                href="https://www.google.com/maps/search/?api=1&query=Hiro+Japanese+Buffet+Aurora+CO"
                target="_blank"
                rel="noopener noreferrer"
              >
                2797 S Parker Rd, Aurora, CO 80014
              </a>
            </div>

            <div className="simple-info-block">
              <h3>Location Hours:</h3>

              <p>
                Monday – Friday
                <br />
                11:00 AM – 3:00 PM
                <br />
                4:30 PM – 9:30 PM
              </p>

              <p>
                Saturday – Sunday
                <br />
                11:00 AM – 9:30 PM
              </p>
            </div>

            <div className="simple-info-block">
              <h3>Phone:</h3>

              <a href="tel:3038739999">(303) 873-9999</a>
            </div>

            <a
              href="https://www.google.com/maps/search/?api=1&query=Hiro+Japanese+Buffet+Aurora+CO"
              target="_blank"
              rel="noopener noreferrer"
              className="simple-direction-button"
            >
              Get Directions
            </a>
          </motion.div>

          {/* RIGHT SIDE */}

          <motion.div
            className="visit-map-container"
            initial={{
              opacity: 0,
              y: 60,
              scale: 0.98,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
              scale: 1,
            }}
            transition={{
              duration: 1,
              delay: 0.15,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{ once: true }}
          >
            <a
              href="https://www.google.com/maps/search/?api=1&query=Hiro+Japanese+Buffet+Aurora+CO"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={customMap}
                alt="Map showing Hiro Japanese Buffet location"
                className="huge-map"
              />
            </a>
          </motion.div>
        </motion.section>
      </div>
    </>
  );
};

export default Address;
